export const getBudgetCenterSubPageMenuStyles = (_components, { palette }) => ({
  BudgetCenterMenuBar: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '28px',
    paddingLeft: 32,
    paddingTop: 14,
    paddingBottom: 14,
    borderBottom: `1px solid ${palette.neutralLight}`,
    display: 'flex',
    flexDirection: 'row',
  },
  LeftContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});
